import React from 'react';
import { Loader } from 'lucide-react';

const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12'
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <Loader className={`animate-spin text-procogia-blue ${sizeClasses[size]}`} />
    </div>
  );
};

export default LoadingSpinner; 